import { ReactNode } from 'react';

import { ChakraText, EquipUITheme } from '@equip.health/ui';

const { paragraph } = EquipUITheme.typography;

interface ErrorMessageProps {
  children: ReactNode;
  id: string;
}

const ErrorMessage = ({ children, id }: ErrorMessageProps) => {
  return (
    <ChakraText
      {...paragraph}
      color="critical.base"
      id={`${id}__error-message`}
    >
      {children}
    </ChakraText>
  );
};

export default ErrorMessage;
